var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenantWalkthrough(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 214,
    viewBox: "0 0 274 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_309_1357)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_309_1357)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M258.531 -3H16.4687C5.16413 -3 -4 6.99101 -4 19.3155V188.684C-4 201.009 5.16413 211 16.4687 211H258.531C269.836 211 279 201.009 279 188.684V19.3155C279 6.99101 269.836 -3 258.531 -3Z",
    fill: "#1467B0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05985 211H265.94C278.118 211 288 200.963 288 188.592V179H-17V188.592C-17 200.963 -7.11839 211 5.05985 211Z",
    fill: "#9FC1DF",
    fillOpacity: 0.89
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4042 41H86.9491V62.4871H98.4042V41Z",
    fill: "#3E519E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M176.609 56.0007H77.8777V78.7922H176.609V56.0007Z",
    fill: "#2C3F84"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.609 181.662H77.8777V77.725L126.674 53.5579L176.609 77.725V181.662Z",
    fill: "#C5CDFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M176.609 173.741H77.8777V181.662H176.609V173.741Z",
    fill: "#9FAFFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.723 137.407H108.081V180.299H147.723V137.407Z",
    fill: "#5363BC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.734 140.692H111.567V181.662H144.734V140.692Z",
    fill: "#3E51A3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.616 171.927H111.579V176.789H144.616V171.927Z",
    fill: "#AEBEFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M141.983 143.325H114.698V149.278H141.983V143.325Z",
    fill: "#2C3F84"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M141.983 150.997H114.698V171.939H141.983V150.997Z",
    fill: "#2C3F84"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M124.919 159.725C124.919 160.365 124.397 160.887 123.757 160.887C123.117 160.887 122.595 160.365 122.595 159.725C122.595 159.084 123.117 158.563 123.757 158.563C124.397 158.563 124.919 159.084 124.919 159.725Z",
    fill: "#AEBEFF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.817 159.725C132.817 160.365 132.295 160.887 131.655 160.887C131.014 160.887 130.493 160.365 130.493 159.725C130.493 159.084 131.014 158.563 131.655 158.563C132.295 158.563 132.817 159.084 132.817 159.725Z",
    fill: "#AEBEFF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83.3695L74.3794 75.1636L126.651 49.8463L180.629 74.8197L179.941 83.0493L126.686 57.2695L74 83.3695Z",
    fill: "#3E519E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.726 142.495H127.03V171.927H128.726V142.495Z",
    fill: "#3E51A3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9178 117.177V100.718C91.9178 94.9431 96.6136 90.2591 102.377 90.2591C108.14 90.2591 112.836 94.955 112.836 100.718V117.177H91.9059H91.9178Z",
    fill: "#9FAFFF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.654 114.995H94.0878V100.718C94.0878 96.1408 97.7994 92.441 102.365 92.441C106.942 92.441 110.642 96.1526 110.642 100.718V114.995H110.654Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M112.089 104.999V102.746H92.6768V104.999H112.089Z",
    fill: "#9FAFFF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.361 91.2908H101.096V103.73H103.361V91.2908Z",
    fill: "#9FAFFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.065 117.177H89.6885V121.826H115.065V117.177Z",
    fill: "#E6EAFF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M115.065 119.869H89.6885V121.932H115.065V119.869Z",
    fill: "#9FAFFF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M145.292 117.177V100.718C145.292 94.9431 149.987 90.2591 155.751 90.2591C161.514 90.2591 166.21 94.955 166.21 100.718V117.177H145.28H145.292Z",
    fill: "#9FAFFF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M164.028 114.995H147.462V100.718C147.462 96.1408 151.173 92.441 155.739 92.441C160.316 92.441 164.016 96.1526 164.016 100.718V114.995H164.028Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M165.463 104.999V102.746H146.051V104.999H165.463Z",
    fill: "#9FAFFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M156.735 91.2908H154.47V103.73H156.735V91.2908Z",
    fill: "#9FAFFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M168.439 117.177H143.062V121.826H168.439V117.177Z",
    fill: "#E6EAFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M168.439 119.869H143.062V121.932H168.439V119.869Z",
    fill: "#9FAFFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147.723 175.923H107.357V181.662H147.723V175.923Z",
    fill: "#E6EAFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M245.582 77.5784C250.987 55.2542 237.271 32.7752 214.947 27.3703C192.623 21.9654 170.144 35.6812 164.739 58.0054C159.334 80.3297 173.05 102.809 195.374 108.214C217.698 113.618 240.177 99.9027 245.582 77.5784Z",
    fill: "#F3E1E6"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M241.053 69.1666C244.971 46.5339 229.799 25.0107 207.167 21.0932C184.534 17.1757 163.011 32.3474 159.093 54.9801C155.176 77.6128 170.347 99.136 192.98 103.053C215.613 106.971 237.136 91.7992 241.053 69.1666Z",
    fill: "#F5F7FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M200.263 95.2362C218.61 95.1049 233.377 80.1253 233.246 61.7783C233.114 43.4313 218.135 28.6646 199.788 28.7959C181.441 28.9272 166.674 43.9068 166.805 62.2538C166.937 80.6008 181.916 95.3675 200.263 95.2362Z",
    fill: "#C5CDFF",
    fillOpacity: 0.38
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M199.368 37.3093C192.746 37.4654 187.38 42.9353 187.35 49.5646C187.328 53.9793 189.632 57.8588 193.11 60.0438C194.195 60.7275 194.864 61.9166 194.864 63.2024V69.0142C194.864 69.3189 194.983 69.6162 195.198 69.8317L196.09 70.7384V86.026C196.09 86.7767 196.425 87.4901 197.004 87.9732L197.198 88.1367C198.349 89.0954 200.037 89.0137 201.092 87.9583L203.79 85.2605C203.916 85.1342 203.983 84.9632 203.983 84.7849V83.9451C203.983 83.6404 203.782 83.3802 203.492 83.2985C203.069 83.187 202.511 82.86 202.437 81.9607C202.34 80.8757 202.883 80.4223 203.299 80.2365C203.582 80.1102 203.76 79.8129 203.76 79.5007L203.723 70.731L204.577 69.8243C204.778 69.6087 204.897 69.3189 204.897 69.0216V62.8902C204.897 61.6491 205.536 60.5045 206.562 59.8134C209.832 57.5986 211.972 53.8603 211.972 49.6167C211.972 42.7198 206.302 37.1458 199.36 37.3093H199.368ZM205.172 57.1304L204.109 56.0676H195.31L194.21 57.1676C191.757 55.4508 190.159 52.6043 190.159 49.3863C190.159 44.1393 194.411 39.8808 199.665 39.8808C204.919 39.8808 209.17 44.1319 209.17 49.3863C209.17 52.582 207.595 55.4062 205.172 57.1304Z",
    fill: "#F0AF46"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M199.665 39.8882C194.418 39.8882 190.159 44.1393 190.159 49.3937C190.159 52.6118 191.765 55.4582 194.21 57.175L195.31 56.0751H204.109L205.172 57.1379C207.587 55.4136 209.17 52.5895 209.17 49.3937C209.17 44.1467 204.919 39.8882 199.665 39.8882ZM199.665 49.2005C198.008 49.2005 196.655 47.8553 196.655 46.1905C196.655 44.5258 198 43.1806 199.665 43.1806C201.33 43.1806 202.675 44.5258 202.675 46.1905C202.675 47.8553 201.33 49.2005 199.665 49.2005Z",
    fill: "#C48A3D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M200.542 59.6053V88.382C200.743 88.2631 200.928 88.1219 201.099 87.9509L202.957 86.0929V83.0161C202.705 82.808 202.496 82.481 202.452 81.9533C202.385 81.1655 202.653 80.7122 202.957 80.452V59.6053H200.542Z",
    fill: "#C48A3D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M197.25 59.6053V88.1739C197.948 88.7313 198.84 88.9171 199.665 88.7387V59.6127H197.25V59.6053Z",
    fill: "#C48A3D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M209.876 43.9163C209.876 43.9163 209.876 44.7636 210.62 45.1129C210.62 45.1129 210.144 47.4391 211.846 47.833C211.846 47.833 211.407 45.1872 210.501 43.7603L209.876 43.9163Z",
    fill: "#C48A3D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M267.718 182H7V186.372H267.718V182Z",
    fill: "#9FAFFF",
    fillOpacity: 0.2
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_309_1357",
    x: 0,
    y: 0,
    width: 274,
    height: 214,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_309_1357"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_309_1357",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_309_1357"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 11C2 5.47715 6.47715 1 12 1H262C267.523 1 272 5.47715 272 11V211H2V11Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenantWalkthrough);
export default __webpack_public_path__ + "static/media/TenantWalkthrough.ec6d450e2bae2d9aa59016b502bb9bdc.svg";
export { ForwardRef as ReactComponent };